<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Bestellung bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.orders.update', order))">
                <form-fields :form="form" :order="order" :order-status-options="orderStatusOptions" :countries="countries" :customers="customers" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'order',
            'countries',
            'customers',
            'orderStatusOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    customer_id: this.order.customer_id,
                    customer_number: this.order.customer_number,
                    supplier_order_number: this.order.supplier_order_number,
                    order_token: this.order.order_token,
                    order_status: this.order.order_status,
                    shipped: this.order.shipped,
                    shipping_date: this.order.shipping_date ? moment(this.order.shipping_date).format('YYYY-MM-DDTHH:mm') : null,
                    subtotal: this.order.subtotal,
                    total: this.order.total,
                    tax: this.order.tax,
                    delivery: this.order.delivery,
                    delivery_tax: this.order.delivery_tax,
                    payment_method_id: this.order.payment_method_id,
                    billing_address_data: this.order.billing_address_data || {country_id: null},
                    delivery_address_data: this.order.delivery_address_data || {country_id: null},
                    delivery_address_same_as_billing_address: this.order.delivery_address_data === null,
                    notes: this.order.notes,
                    tracking_url: this.order.tracking_url,
                    tracking_code: this.order.tracking_code,
                    order_date: this.order.order_date ? moment(this.order.order_date).format('YYYY-MM-DDTHH:mm') : null,
                    order_items: this.order.order_items,
                    delivery_option_id: this.order.delivery_option_id, // @todo genauso ablegen wie adresses, falls später gelöscht wird?
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>